module.exports = __webpack_public_path__ + "static/media/img_suitcase.18c1999c.svg";